import initApple from './initApple';
import initFb from './initFb';
import initGp from './initGp';
import initVk from './initVk';
import initTinkoff from './initTinkoff';
import initYandex from './initYandex';
export var id = {
  apple: 'ru.s7.s7app.serviceId',
  fb: '249939988732776',
  gp: '932080211557-rjishug1msc6s2jj8gorcf6o7a89096r.apps.googleusercontent.com',
  vk: '5098785',
  tinkoff: 's7-airlines',
  yandex: 'e59524ff8dcf49fc9c7652edad984ad2'
};
export default function initSocials() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      socialApple = _ref.socialApple,
      socialFacebook = _ref.socialFacebook,
      socialGoogle = _ref.socialGoogle,
      socialTinkoff = _ref.socialTinkoff,
      socialVk = _ref.socialVk,
      socialYandex = _ref.socialYandex;

  if (socialApple) {
    initApple(parameters.apple || {
      clientId: id.apple
    });
  }

  if (socialFacebook) {
    initFb(parameters.fb || {
      appId: id.fb
    });
  }

  if (socialGoogle) {
    initGp(parameters.gp || id.gp);
  }

  if (socialTinkoff) {
    initTinkoff(parameters.tinkoff || id.tinkoff);
  }

  if (socialVk) {
    initVk(parameters.vk || id.vk);
  }

  if (socialYandex) {
    initYandex(parameters.yandex || id.yandex);
  }
}